import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import SubscriptionCategoryTable from '@subscriptions/components/tables/subscription-category-table/subscription-category-table.vue';
import { Observable } from 'rxjs';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { Contact } from '@contacts/interfaces/contact';

@Component({
  name: 'bpc-profile-subscriptions',
  components: {
    'bpc-subscription-category-table': SubscriptionCategoryTable,
  },
})
export default class ProfileSubscriptionsAvailable extends Vue {
  public contactObservableSubscription = null;
  public contactRelationsObservableSubscription = null;
  public contacts: Contact[] = [];

  /* Lifecycle hooks */
  created() {
    this.getContact();
    this.getContactRelations();
  }
  // mounted () { }
  // updated () { }
  // destroyed () { }

  public getContact(): void {
    const contactId = this.$authorizationService.getContactId();
    const fetchEntityPath = `${this.$bpcApiRouteHelper.getEntityPath(
      'contact',
      'raw',
    )}/${contactId}`;
    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.get(fetchEntityPath);

    if (this.contactObservableSubscription) {
      this.contactObservableSubscription.unsubscribe();
    }

    this.contactObservableSubscription = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.contacts.push(res.data);
      },
      error => {
        console.log(error);
      },
    );
  }

  public getContactRelations(): void {
    const fetchEntityPath = `${this.$bpcApiRouteHelper.getEntityPath('contact-relations', 'raw')}`;

    const queryConfig = {
      params: {
        contact_id: this.$authorizationService.getContactId(),
      },
    };
    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.get(
      fetchEntityPath,
      queryConfig,
    );

    if (this.contactRelationsObservableSubscription) {
      this.contactRelationsObservableSubscription.unsubscribe();
    }

    this.contactRelationsObservableSubscription = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        if (res.data) {
          res.data.forEach(contactRelation => {
            this.contacts.push(contactRelation['relatedContact']);
          });
        }
      },
      error => {
        console.log(error);
      },
    );
  }
}
